import React, {useEffect, useState} from 'react';
import {DatePicker} from 'antd';
import {ConfigProvider} from 'antd';
import locale from 'antd/locale/fr_FR';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/fr';
import './datepicker.css';

import suffix from '../../../assets/icons/datepicker/suffix.png';
import separator from '../../../assets/icons/datepicker/separator.png';
import suffixBlue from '../../../assets/icons/blueStyle/calendar-blue.png';

type DatepickerProps = {
    defaultValue: any;
    onChange: (e: { startDate: Date | null; endDate: Date | null } | { date: Date | null }) => void;
    type: 'basic' | 'range';
    picker: 'week' | 'month' | 'quarter' | 'year' | 'date';
    disabled: boolean;
    allowClear: boolean;
    blueStyle: boolean;
}

const Datepicker = ({
    defaultValue = null,
    onChange = () => {return null;},
    type = 'basic',
    picker = 'date',
    disabled = false,
    allowClear = true,
    blueStyle = false
}: DatepickerProps) => {
    const {RangePicker} = DatePicker;

    const [value, setValue] = useState<Dayjs | [Dayjs | null, Dayjs | null] | null>(null);

    const handleChange = (e: Dayjs | [Dayjs | null, Dayjs | null] | null) => {
        setValue(e);

        if (type === 'range' && Array.isArray(e)) {
            const dateValue = {
                startDate: e[0] ? e[0].toDate() : null,
                endDate: e[1] ? e[1].toDate() : null
            };
            onChange(dateValue);
        }
        else if (e && !Array.isArray(e)) {
            const dateValue = {
                date: e.toDate()
            };
            onChange(dateValue);
        }
    };

    useEffect( () => {
        if (defaultValue && type === 'basic') {
            Object.keys(defaultValue).length === 1 &&
            setValue(dayjs(defaultValue.date));
        }
        else if (defaultValue && type === 'range') {
            Object.keys(defaultValue).length === 2 &&
            setValue([dayjs(defaultValue.startDate), dayjs(defaultValue.endDate)]);
        }
    }, [defaultValue, type]);

    return (
        <ConfigProvider locale={locale}>
            {
                type === 'range' && Array.isArray(value) ?
                    <RangePicker
                        value={value}
                        onChange={handleChange}
                        picker={picker}
                        format="DD/MM/YYYY"
                        disabled={disabled}
                        allowClear={allowClear}
                        suffixIcon={<img src={blueStyle ? suffixBlue : suffix} alt='icon' className="w-6"/>}
                        separator={<img src={separator} alt='icon' className="w-4"/>}
                        className="main-date-picker"
                    /> :
                    <DatePicker
                        value={value as Dayjs | null}
                        onChange={handleChange}
                        picker={picker}
                        format="DD/MM/YYYY"
                        disabled={disabled}
                        allowClear={allowClear}
                        suffixIcon={<img src={blueStyle ? suffixBlue : suffix} alt='icon' className="w-6"/>}
                        className="main-date-picker"
                    />
            }
        </ConfigProvider>
    );
};

export default Datepicker;
